/**
 * Created by Sandon on 2019-07-03.
 */
const common = {
  // 获取价格/数量小数点位数
  digits: {
    url: '/mall/overall/configure',
    type: 'get',
    parameter: {}
  },
  // 获取币种list
  currencyList: {
    url: '/mall/currency/list',
    type: 'post'
  },
  // 获取本位币
  currencyBase: {
    url: '/mall/currency/base',
    type: 'get'
  },
  // 获取汇率
  getExchangeRate: {
    url: '/mall/currency/getExchangeRate',
    type: 'post'
  }
}
export default common
